import gql from "graphql-tag";
import Client from "Apolloclient";
import store from "store/store";
import * as types from './uorg.types';
import * as actions from './uorg.actions';

export function SalvaUorg(number, description, customerid, contractid) {

    var variables = {number, description, customerid, contractid};


    let query = {
        fetchPolicy: 'no-cache',
        variables: variables,
        mutation: gql`,
            mutation create (
            $number: String!
            $description: String
            $contractid: String!
        ) {
            createdObject: createUorg (
                number: $number,
                description: $description,
                contractid: $contractid
            ) {
                id
                number
                description
                contract {
                    id
                    description
                    startDate
                    endDate
                    company
                } 
            }
        }
        `
    };

    return Client
        .mutate(query)
        .then(async (response) => {
            var data = response.data.createdObject;

            if (process.env.NODE_ENV === 'development') {
                data = JSON.parse(JSON.stringify(data));
            }

            store.dispatch(actions.created(data));

            return {
                hasError: false,
                data
            }
        })
        .catch((e) => {
            var message = 'Impossibile creare lo UORG';
            console.error(e);

            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                message = e.graphQLErrors[0].message;
            }

            return {
                hasError: true,
                message: message
            };
        });
}

export function OttieniUorg() {

    store.dispatch({
        type: types.REQUEST_READ_ALL
    });

    var variables = {};

    let query = {
        fetchPolicy: 'network-only',
        variables: variables,
        query: gql`,
        {
            objectList : getUorgs {
                id
                number
                description
                contract {
                    description
                    id
                }
            }
        }        `,
    };
    return Client
        .query(query).then(
            async response => {

                var data = response.data.objectList;



                store.dispatch(
                    {
                        type: types.READED_ALL,
                        payload: data
                    }
                );

                return;
            }
        ).catch(
            e => {
                var message = "Impossibile ottenere gli UORG";
                console.error(e);

                if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                    message = e.graphQLErrors[0].message;
                }

                store.dispatch({
                    type: types.READ_ALL_ERROR
                });

                return {
                    hasError: true,
                    message: message
                }
            }
        );
}

export function AggiornaUorg(id, number, description, contractid) {

    var variables = {id, number, description, contractid};

    let query = {
        fetchPolicy: 'no-cache',
        variables: variables,
        mutation: gql`,
        mutation update(
            $id: String!,
            $number: String,
            $description: String,
            $contractid: String
        ){
            updatedObject: updateUorg(
                id: $id,
                number: $number,
                description: $description,
                contractid: $contractid
            ) {
                id
                number
                description
                contract {
                    description
                    id
                }
            }
        }
        `
    };

    return Client
        .mutate(query)
        .then(async (response) => {
            var data = response.data.updatedObject;

            store.dispatch(actions.updated(data));

            return {
                hasError: false
            }
        })
        .catch((e) => {
            var message = 'Impossibile aggiornare lo UORG';
            console.error(e);

            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                message = e.graphQLErrors[0].message;
            }
            return {
                hasError: true,
                message: message
            }
        });
}

export function EliminaUorg(id) {

    var variables = {id};

    let query = {
        fetchPolicy: 'no-cache',
        variables: variables,
        mutation: gql`,
        mutation (
            $id: String!
        ) {
            deleted: deleteUorg (id: $id) {
                id
                number
                description
            }
        }
        `
    };

    store.dispatch(actions.requestDelete(id));

    return Client
        .mutate(query)
        .then(async (response) => {
            var data = response.data.deleted;

            store.dispatch(actions.deleted(data));

            return {
                hasError: false
            }
        })
        .catch((e) => {
            var message = 'Impossibile eliminare lo UORG';
            console.error(e);
            store.dispatch(actions.deleteError(id));


            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                message = e.graphQLErrors[0].message;
            }

            return {
                hasError: true,
                message: message
            }
        });
}
